enum ETeamPlayerStatus {
    "Pending",
    "Accepted",
    "Rejected"
}

export default ETeamPlayerStatus